module.exports = __webpack_public_path__ + "img/avtar.b93464ae.jpg";